import React from 'react';
import Button from 'components/button/ActionButton';
import Column from 'components/ui/show/Column';
import ConfigurationInputField from './ConfigurationInputField';
import HeaderColumn from 'components/ui/table/HeaderColumn';
import InnerColumn from 'components/ui/show/InnerColumn';
import NoResults from 'components/form/styling/NoResults';
import PropTypes from 'prop-types';
import Section from 'components/ui/general/Section';
import Table from 'components/ui/table/Table';
import TableRow from 'components/ui/table/TableRow';
import translate from 'components/hoc/translate';
import theme from 'theme/theme';
import utils from 'helpers/utils';
import { AddIcon, DeleteIcon } from 'assets/materialIcons/materialIcons';
import { TableRowColumn } from 'material-ui/Table';
import { compose } from 'recompose';
import differenceWith from 'lodash/differenceWith';
import isEqualWith from 'lodash/isEqualWith';
import { isEmpty } from 'lodash';

class ArrayConfiguration extends React.Component {
    shouldComponentUpdate(nextProps) {
        return (this.props.values !== nextProps.values ||
            !utils.isEmpty(differenceWith(nextProps.values, this.props.values, isEqualWith))) || nextProps.errors !== this.props.errors;
    }

    onAdd = () => {
        const { onAdd, name } = this.props;

        return onAdd(name);
    }

    onChange = (event, value) => {
        const { onChange, name } = this.props;

        const values = { ...value };

        values[event.target.name] = event.target.value;

        return onChange(event, values, name);
    }

    onDelete = (id) => {
        const { onDelete, name, values } = this.props;

        return onDelete(id, name, values);
    }

    getFieldInputStyle = (fieldName) => {
        const {
            fieldInputWrapperStyles,
        } = this.props;

        return fieldInputWrapperStyles[fieldName] || null;
    };

    render() {
        const {
            component: TableCellComponent,
            components,
            errors,
            fields,
            id,
            inputComponentProps,
            name,
            placeholder,
            translate,
            type,
            values,
            title,
        } = this.props;

        return (
            <Section>
                <Column
                    errorMessage={ errors[name] || '' }
                    title={ title }
                >
                    <InnerColumn>

                        {
                            isEmpty(values) ?
                                (
                                    <div>
                                        <NoResults
                                            label={ translate(`resources.products.${ name }.no_result`, {
                                                type: translate(`resources.products.${ name }.types.${ type }.plural`),
                                            }) }
                                        />
                                        <Button
                                            icon={ <AddIcon color={ theme.palette.gray }/> }
                                            title={ translate(`resources.products.${ name }.add`, {
                                                type: translate(`resources.products.${ name }.types.${ type }.singular`),
                                            }) }
                                            onClick={ this.onAdd }
                                            primary={ true }
                                        />
                                    </div>
                                ) :
                                (
                                    <Table id={ id } responsive='scroll'>
                                        <TableRow>
                                            {
                                                utils.map(fields, (field) => {
                                                    const width = `${ (100 - 5) / fields.length }%`;

                                                    return (
                                                        <HeaderColumn
                                                            key={ `header-${ field }` }
                                                            style={ { width: width } }
                                                        >
                                                            { translate(`resources.products.fields.${ field }`) }
                                                        </HeaderColumn>
                                                    );
                                                })
                                            }
                                        </TableRow>

                                        {
                                            utils.map(values, (value, key) => {
                                                const {
                                                    id,
                                                } = value;

                                                return (
                                                    <TableRow key={ `${ id }-${ key }` }>
                                                        {
                                                            utils.map(fields, (field, index) => {
                                                                let paddingLeft = 0;
                                                                const fieldWrapperStyle = this.getFieldInputStyle(field);

                                                                if (index === 0) {
                                                                    paddingLeft = 12;
                                                                }

                                                                const props = {
                                                                    key: `cell-${ field }-${ index }`,
                                                                    ...(fieldWrapperStyle && { inputWrapperStyle: fieldWrapperStyle }),
                                                                    name: field,
                                                                    onChangeInput: this.onChange,
                                                                    placeholder: placeholder,
                                                                    style: {
                                                                        paddingLeft: paddingLeft,
                                                                    },
                                                                    value: value || {},
                                                                    ...inputComponentProps,
                                                                };

                                                                if (components && components[field]) {
                                                                    return React.cloneElement(components[field], props);
                                                                }

                                                                return <TableCellComponent { ...props } />;
                                                            })
                                                        }

                                                        <TableRowColumn>
                                                            <Button
                                                                icon={ <DeleteIcon color={ theme.palette.redOrange }/> }
                                                                title=''
                                                                onClick={ () => {
                                                                    return this.onDelete(id);
                                                                } }
                                                                primary={ false }
                                                            />
                                                        </TableRowColumn>
                                                    </TableRow>
                                                );
                                            })
                                        }

                                        <TableRow>
                                            <TableRowColumn colSpan={ 3 }>
                                                <Button
                                                    icon={ <AddIcon color={ theme.palette.gray }/> }
                                                    title={ translate(`resources.products.${ name }.add`, {
                                                        type: translate(`resources.products.${ name }.types.${ type }.singular`),
                                                    }) }
                                                    onClick={ this.onAdd }
                                                    primary={ false }
                                                />
                                            </TableRowColumn>
                                        </TableRow>
                                    </Table>
                                )
                        }

                    </InnerColumn>
                </Column>
            </Section>
        );
    }
}

ArrayConfiguration.defaultProps = {
    errors: {},
    fieldInputWrapperStyles: {},
    fields: [
        'from',
        'to',
    ],
    inputComponentProps: {},
};

ArrayConfiguration.propTypes = {
    component: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.func,
        PropTypes.node,
    ]).isRequired,
    components: PropTypes.object,
    errors: PropTypes.object,
    fields: PropTypes.arrayOf(PropTypes.string),
    fieldInputWrapperStyles: PropTypes.object,
    id: PropTypes.string.isRequired,
    inputComponentProps: PropTypes.object,
    name: PropTypes.string.isRequired,
    onAdd: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    translate: PropTypes.func.isRequired,
    type: PropTypes.string,
    values: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([
            PropTypes.number.isRequired,
            PropTypes.string.isRequired,
        ]),
    })),
    title: PropTypes.string,
};

const enhance = compose(
    translate,
    ConfigurationInputField,
);

export default enhance(ArrayConfiguration);



// WEBPACK FOOTER //
// ./src/pages/products/configuration/ArrayConfiguration.js